import api from '../api';

export const FLAVOUR_SWITCH_REQUEST = 'FLAVOUR_SWITCH_REQUEST';
export const FLAVOUR_SWITCH_SUCCESS = 'FLAVOUR_SWITCH_SUCCESS';
export const FLAVOUR_SWITCH_FAIL = 'FLAVOUR_SWITCH_FAIL';
export const PANEL_FETCH_REQUEST = 'PANEL_FETCH_REQUEST';
export const PANEL_FETCH_SUCCESS = 'PANEL_FETCH_SUCCESS';
export const PANEL_FETCH_FAIL = 'PANEL_FETCH_FAIL';
export const PLEROMA_CONFIG_FETCH_REQUEST = 'PLEROMA_CONFIG_FETCH_REQUEST';
export const PLEROMA_CONFIG_FETCH_SUCCESS = 'PLEROMA_CONFIG_FETCH_SUCCESS';
export const PLEROMA_CONFIG_FETCH_FAIL = 'PLEROMA_CONFIG_FETCH_FAIL';

export function switchFlavour(flavour) {
  return (dispatch, getState) => {
    dispatch(switchFlavourRequest());
    if(flavour === undefined) {
      flavour = 'glitch';
    }

    api(getState).post('/api/v1/pleroma/flavour/'+flavour).then(response => {
      dispatch(switchFlavourSuccess(response.data));
      location.href = '/web/getting-started';
    }).catch(error => {
      dispatch(switchFlavourFail(error));
    });
  };
};

export function fetchPanel() {
  return (dispatch, getState) => {
    dispatch(fetchPanelRequest());

    api(getState).get('/instance/panel.html').then(response => {
      dispatch(fetchPanelSuccess(response.data));
    }).catch(error => {
      dispatch(fetchPanelFail(error));
    });
  };
};

export function fetchPleromaConfig() {
  return (dispatch, getState) => {
    dispatch(fetchPleromaConfigRequest());

    api(getState).get('/api/pleroma/frontend_configurations').then(response => {
      dispatch(fetchPleromaConfigSuccess(response.data.masto_fe));
    }).catch(error => {
      dispatch(fetchPleromaConfigFail(error));
    });
  };
};

export function switchFlavourRequest() {
  return {
    type: FLAVOUR_SWITCH_REQUEST,
  };
};

export function switchFlavourSuccess(tos) {
  return {
    type: FLAVOUR_SWITCH_SUCCESS,
    tos,
  };
};

export function switchFlavourFail(error) {
  return {
    type: FLAVOUR_SWITCH_FAIL,
    error,
  };
};


export function fetchPanelRequest() {
  return {
    type: PANEL_FETCH_REQUEST,
  };
};

export function fetchPanelSuccess(panel) {
  return {
    type: PANEL_FETCH_SUCCESS,
    panel,
  };
};

export function fetchPanelFail(error) {
  return {
    type: PANEL_FETCH_FAIL,
    error,
  };
};

export function fetchPleromaConfigRequest() {
  return {
    type: PLEROMA_CONFIG_FETCH_REQUEST,
  };
};

export function fetchPleromaConfigSuccess(config) {
  return {
    type: PLEROMA_CONFIG_FETCH_SUCCESS,
    config,
  };
};

export function fetchPleromaConfigFail(error) {
  return {
    type: PLEROMA_CONFIG_FETCH_FAIL,
    error,
  };
};
